import type ModelRegistry from 'ember-data/types/registries/model';
import ApplicationAdapter from 'volta/_pods/application/adapter';

export default class SkuTaskAdapter extends ApplicationAdapter {
  pathForType<K extends keyof ModelRegistry>(_modelName: K): string {
    return 'skus/tasks';
  }
}
